<template>
<d-phone
  v-if="type === 'tel'"
  ref="input"
  :filling="true"
  :style="styleList"
  icon-arrow-flag="@more"
  icon="close"
  v-bind="$props"
  class="c-input c-input--tel"
/>
<d-input
  v-else
  ref="input"
  :style="styleList"
  v-bind="$props"
  class="c-input"
  icon-visibility="outlined-visibility"
  icon-visibility-off="outlined-visibility_off"
/>
</template>

<script>
import DInput from 'dcode/components/DInput'
import DPhone from 'dcode/components/DPhone'
import { computed, ref } from 'vue'

export default {
  name: 'CInput',
  components: {
    DInput,
    DPhone
  },
  props: [
    // Values
    'value',
    'name',
    'text',
    'prefix',
    'suffix',
    'helperMessage',
    'validationMessage',

    // Input
    'min',
    'max',
    'minlength',
    'maxlength',
    'pattern',
    'placeholder',
    'required',

    // Status
    'readonly',
    'disabled',

    // Options
    'type',
    'adaptive',
    'counter',
    'width',

    // Icon
    'icon',
    'iconTrailing'
  ],
  setup (props) {
    return {
      input: ref(undefined),
      styleList: computed(() => {
        return { '--cf-width': props.width }
      })
    }
  }
}
</script>

<style lang="scss">
@import "~dcode/styles/margin";
.c-input {
  --cf-palette-type2: var(--basic-type1);
  &--tel {
    .d-carcass-field__slot-left {
      .bt-trailing {
        @include marginDirectionRight(-12px);
      }
    }
  }
}
</style>
